const fieldsArr = [
 
  {
    label: "Item Descrption",
    name: "NIELSEN_ITEM_DESCRIPTION",
    validation: e => {
      const name = e.target.value;
      if (name.length > 1) {
        return false;
      } else {
        return true;
      }
    },
    error: "error"
  },
  {
    label: "UPC",
    name: "NIELSEN_UPC",
    validation: e => {
      const name = e.target.value;
      if (name.length > 1) {
        return false;
      } else {
        return true;
      }
    },
    error: "error"
  },
  {
      label: "Sub Category",
      name: "NIELSEN_SUB_CATEGORY",
      validation: e => {
        const name = e.target.value;
        if (name.length > 1) {
          return false;
        } else {
          return true;
        }
      },
      error: "error"
  },
  {
      label: "Segment",
      name: "NIELSEN_SEGMENT",
      validation: e => {
        const name = e.target.value;
        if (name.length > 1) {
          return false;
        } else {
          return true;
        }
      },
      error: "error"
  },
  {
    label: "Sub Segment",
    name: "NIELSEN_SUB_SEGMENT",
    validation: (e, a) => {
        const name = e.target.value;
        return name.length <= 5;
    },
    error: "error"
  },
  {
    label: "Brand",
    name: "NIELSEN_BRAND",
    validation: e => {
      const name = e.target.value;
      if (name.length > 1) {
        return false;
      } else {
        return true;
      }
    },
    error: "error"
},
{
  label: "SKU Size",
  name: "NIELSEN_SKU_SIZE",
  validation: e => {
    const name = e.target.value;
    if (name.length > 1) {
      return false;
    } else {
      return true;
    }
  },
  error: "error"
},
{
  label: "Pack type",
  name: "NIELSEN_PACK_SIZE",
  validation: e => {
    const name = e.target.value;
    if (name.length > 1) {
      return false;
    } else {
      return true;
    }
  },
  error: "error"
} 
  ];
  
  export default fieldsArr;
  